export const SET_LOADER = 'CATEGORIES/SET_LOADER';
export const SET_CATEGORIES = 'CATEGORIES/SET_CATEGORIES';

export const SET_PRODUCTS = 'CATEGORIES/SET_PRODUCTS';
export const SET_PRODUCTS_LOADER = 'CATEGORIES/SET_PRODUCTS_LOADER';
export const SET_PAGE = 'CATEGORIES/SET_PAGE';
export const FETCH_FILTERS = 'CATEGORIES/FETCH_FILTERS';
export const SET_FILTERS_LOADER = 'CATEGORIES/SET_FILTERS_LOADER';

export const SET_FILTER = 'CATEGORIES/SET_FILTER';
export const RESET_FILTERS = 'CATEGORIES/RESET_FILTERS';

export const FETCH_FILTERS_ERROR = 'CATEGORIES/FETCH_FILTERS_ERROR';

export const SET_SELECTED_FILTERS = 'CATEGORIES/SET_SELECTED_FILTERS';
